import gsap from '../../../gsap-public/esm/index.js';

class PortfolioGrid {
  constructor() {
    this.grid = document.querySelector('[data-portfolio-grid]');
    this.filters = document.querySelectorAll('[data-filter]');
    this.cards = document.querySelectorAll('.portfolio-card');

    if (this.grid && this.filters.length > 0) {
      this.bindFilters();
    }
  }

  bindFilters() {
    this.filters.forEach(filter => {
      filter.addEventListener('click', (e) => {
        const category = e.target.dataset.filter;
        this.filterCards(category);

        // Update active state
        this.filters.forEach(f => f.classList.remove('active'));
        e.target.classList.add('active');
      });
    });
  }

  filterCards(category) {
    this.cards.forEach(card => {
      const cardCategory = card.dataset.category;
      const shouldShow = category === 'all' || cardCategory === category;

      if (shouldShow) {
        gsap.to(card, {
          opacity: 1,
          scale: 1,
          display: 'block',
          duration: 0.4,
          ease: 'power2.out'
        });
      } else {
        gsap.to(card, {
          opacity: 0,
          scale: 0.8,
          duration: 0.3,
          ease: 'power2.in',
          onComplete: () => {
            gsap.set(card, { display: 'none' });
          }
        });
      }
    });

    // Animate visible cards
    setTimeout(() => {
      this.animateVisibleCards();
    }, 300);
  }

  animateVisibleCards() {
    const visibleCards = Array.from(this.cards).filter(
      card => gsap.getProperty(card, 'display') !== 'none'
    );

    gsap.from(visibleCards, {
      y: 20,
      opacity: 0,
      stagger: 0.05,
      duration: 0.5,
      ease: 'power2.out',
      clearProps: 'all'
    });
  }
}

export default PortfolioGrid;
